/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Polygon,
    PolygonFromJSON,
    PolygonFromJSONTyped,
    PolygonToJSON,
} from './Polygon';
import {
    Radius,
    RadiusFromJSON,
    RadiusFromJSONTyped,
    RadiusToJSON,
} from './Radius';

/**
 *
 * @export
 * @interface IncentivePlanDeviceEligibility
 */
export interface IncentivePlanDeviceEligibility {
    /**
     *
     * @type {Array<Polygon>}
     * @memberof IncentivePlanDeviceEligibility
     */
    polygonRestrictions?: Array<Polygon>;
    /**
     *
     * @type {Array<Radius>}
     * @memberof IncentivePlanDeviceEligibility
     */
    radiusRestrictions?: Array<Radius>;
}

export function IncentivePlanDeviceEligibilityFromJSON(json: any): IncentivePlanDeviceEligibility {
    return IncentivePlanDeviceEligibilityFromJSONTyped(json, false);
}

export function IncentivePlanDeviceEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncentivePlanDeviceEligibility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'polygonRestrictions': !exists(json, 'polygonRestrictions') ? undefined : ((json['polygonRestrictions'] as Array<any>).map(PolygonFromJSON)),
        'radiusRestrictions': !exists(json, 'radiusRestrictions') ? undefined : ((json['radiusRestrictions'] as Array<any>).map(RadiusFromJSON)),
    };
}

export function IncentivePlanDeviceEligibilityToJSON(value?: IncentivePlanDeviceEligibility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'polygonRestrictions': value.polygonRestrictions === undefined ? undefined : ((value.polygonRestrictions as Array<any>).map(PolygonToJSON)),
        'radiusRestrictions': value.radiusRestrictions === undefined ? undefined : ((value.radiusRestrictions as Array<any>).map(RadiusToJSON)),
    };
}

